import { render, staticRenderFns } from "./ShopStocktaking.vue?vue&type=template&id=f38e2288&"
import script from "./ShopStocktaking.vue?vue&type=script&lang=js&"
export * from "./ShopStocktaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports